module.exports = __webpack_public_path__ + "static/img/1076.0a77309.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1076.jpg
// module id = 258
// module chunks = 0